import { __decorate, __param, __metadata } from 'tslib';
import { InjectionToken, Injectable, Inject, Input, Directive, ElementRef, Renderer2, NgModule } from '@angular/core';
import { polyfillPrepend } from '@uikit/components/helpers';
import { Observable } from 'rxjs';

var UK_ICONS_PATH = new InjectionToken('UK_ICONS_PATH');

var UkIconsService = /** @class */ (function () {
    function UkIconsService(svgPath) {
        this.svgPath = svgPath;
        // tslint:disable-next-line: curly
        if (!svgPath)
            throw new Error('UK_ICONS_PATH is required');
    }
    /**
     * Gets Assets with a  XMLHttpRequest
     * @returns  Observable<string>
     */
    UkIconsService.prototype.getAsset = function () {
        var _this = this;
        return new Observable(function (observer) {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', _this.svgPath, false);
            xhr.addEventListener('readystatechange', function (_) {
                if (xhr.readyState === 4 && xhr.status !== 404) {
                    observer.next(xhr.responseText);
                }
                else {
                    observer.error('Error getting SVG icons file');
                }
            });
            xhr.send();
        });
    };
    UkIconsService = __decorate([
        Injectable(),
        __param(0, Inject(UK_ICONS_PATH)),
        __metadata("design:paramtypes", [String])
    ], UkIconsService);
    return UkIconsService;
}());

var cachedDocument = document.implementation.createHTMLDocument('');
var UkIconDirective = /** @class */ (function () {
    function UkIconDirective(el, renderer, iconsService) {
        this.el = el;
        this.renderer = renderer;
        this.iconsService = iconsService;
        this.svgns = "http://www.w3.org/2000/svg";
        this.xlinkns = "http://www.w3.org/1999/xlink";
        this.position = 'left';
    }
    UkIconDirective.prototype.createIcon = function () {
        var _this = this;
        this.iconsService.getAsset().subscribe(function (file) {
            cachedDocument.body.innerHTML = file;
            var svg = document.createElementNS(_this.svgns, 'svg');
            var icon = cachedDocument.getElementById("bofi-" + _this.iconName);
            svg.setAttribute('fit', '');
            svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
            svg.setAttribute('width', '100%');
            svg.setAttribute('height', '100%');
            svg.setAttribute('viewBox', icon.getAttribute('viewBox'));
            svg.appendChild(icon.firstElementChild);
            if (_this.rotation) {
                _this.renderer.setStyle(svg, 'transform', "rotate(" + _this.rotation + "deg)");
            }
            if (_this.color) {
                if (_this.color.indexOf('#') === 0) {
                    svg.setAttribute('fill', _this.color);
                }
                else {
                    svg.classList.add('uk-text-' + _this.color);
                }
            }
            _this.attachImage(svg);
        }, function (err) { return console.warn(err); });
    };
    UkIconDirective.prototype.attachImage = function (svg) {
        // Add Common images
        svg.classList.add('uk-icon');
        if (this.iconTitle) {
            svg.setAttribute('title', this.iconTitle);
            svg.setAttribute('role', 'img');
        }
        else {
            svg.setAttribute('aria-hidden', 'true');
            svg.setAttribute('role', 'presentation');
        }
        // attach Image to DOM
        if (this.position === 'left') {
            this.el.nativeElement.prepend(svg);
        }
        else {
            this.el.nativeElement.appendChild(svg);
        }
    };
    UkIconDirective.prototype.ngOnInit = function () {
        // Add prepend method to document/window for better compatibility with IE
        polyfillPrepend();
        this.createIcon();
    };
    __decorate([
        Input('ukIcon'),
        __metadata("design:type", String)
    ], UkIconDirective.prototype, "iconName", void 0);
    __decorate([
        Input('ukIconTitle'),
        __metadata("design:type", String)
    ], UkIconDirective.prototype, "iconTitle", void 0);
    __decorate([
        Input('ukIconPosition'),
        __metadata("design:type", String)
    ], UkIconDirective.prototype, "position", void 0);
    __decorate([
        Input('ukIconColor'),
        __metadata("design:type", String)
    ], UkIconDirective.prototype, "color", void 0);
    __decorate([
        Input('ukIconRotation'),
        __metadata("design:type", Number)
    ], UkIconDirective.prototype, "rotation", void 0);
    UkIconDirective = __decorate([
        Directive({
            selector: '[ukIcon]'
        }),
        __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            UkIconsService])
    ], UkIconDirective);
    return UkIconDirective;
}());

var UIKitIconsModule = /** @class */ (function () {
    function UIKitIconsModule() {
    }
    UIKitIconsModule_1 = UIKitIconsModule;
    UIKitIconsModule.forRoot = function (iconsPath) {
        return {
            ngModule: UIKitIconsModule_1,
            providers: [{ provide: UK_ICONS_PATH, useValue: iconsPath }]
        };
    };
    var UIKitIconsModule_1;
    UIKitIconsModule = UIKitIconsModule_1 = __decorate([
        NgModule({
            declarations: [UkIconDirective],
            exports: [UkIconDirective],
            providers: [UkIconsService]
        })
    ], UIKitIconsModule);
    return UIKitIconsModule;
}());

export { UIKitIconsModule, UK_ICONS_PATH, UkIconDirective as ɵa, UkIconsService as ɵb };
//# sourceMappingURL=uikit-components-uk-icons.js.map
